import { Grid } from "@mui/material";
import { FormikTextField } from "@shared";
import { ClientPersonalDataMaxLength } from "@shared";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { DropdownOptions } from "@/common/hooks/useDropdownOptions";
import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<EditClientType>;
  dropdownOptions: DropdownOptions;
}

export function PersonalDataNameSection({ formik, dropdownOptions }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <Grid size={4}>
        <FormikAutocomplete
          formik={formik}
          fieldName="salutation"
          label={t("clients.create.salutation")}
          options={dropdownOptions.salutations}
          required
        />
      </Grid>
      <Grid size={4}>
        <FormikAutocomplete
          formik={formik}
          fieldName="title"
          label={t("clients.create.title")}
          options={dropdownOptions.titles}
          freeSolo
        />
      </Grid>
      <Grid size={4} />
      <Grid size={4}>
        <FormikTextField
          formik={formik}
          fieldName="firstName"
          label={t("clients.create.name")}
          slotProps={{ input: { inputProps: { maxLength: ClientPersonalDataMaxLength.firstName } } }}
          required
        />
      </Grid>
      <Grid size={4}>
        <FormikTextField
          formik={formik}
          fieldName="lastName"
          label={t("clients.create.lastName")}
          slotProps={{ input: { inputProps: { maxLength: ClientPersonalDataMaxLength.lastName } } }}
          required
        />
      </Grid>
      <Grid size={4}>
        <FormikTextField
          formik={formik}
          fieldName="formerLastName"
          label={t("clients.create.formerLastName")}
          slotProps={{ input: { inputProps: { maxLength: ClientPersonalDataMaxLength.formerLastName } } }}
        />
      </Grid>
    </Grid>
  );
}
